module.exports = __webpack_public_path__ + "static/img/12.b67a44e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/12.png
// module id = Ha+X
// module chunks = 0